import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import TextLabel, { ColorType, SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'
import './Counter.css'

export const BackgroundColorType = {
  ACCENT: 'accent',
  BASE: 'base',
  RED: 'red'
}

const Counter = ({ title, count, unit, backgroundColor, isTimeup }) => {
  if (isTimeup) {
    return (
      <div styleName={'red container'}>
        <span styleName="timeup-text">
          受付
          <br />
          終了
        </span>
      </div>
    )
  }
  return (
    <div styleName={`${backgroundColor} container`}>
      <div styleName="title">
        <TextLabel color={ColorType.WHITE} size={SizeType.TINY} wight={WeightType.HEAVY}>
          {title}
        </TextLabel>
      </div>
      <div styleName="content">
        <span styleName="count">{Math.ceil(count)}</span>
        <span styleName="unit">{unit}</span>
      </div>
    </div>
  )
}

Counter.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  isTimeup: PropTypes.bool.isRequired
}

Counter.defaultProps = {
  isTimeup: false
}

export default compose(pure)(Counter)
